import moment from "moment";

class MomentHelper {
    static getSecondsDuration = (moment) => {
        const duration = moment.second() + moment.minute() * 60 + moment.hour() * 3600;
        return duration
    }

    static shortenTimeRangeFormat = (timeRange) => {

        //input format: "HH:mm:ss - HH:mm:ss"
        // Split the string into start and end times
        const [start, end] = timeRange.split(" - ");

        // Format both times to short format (e.g., 12 PM, 1 PM)
        const label = `${moment(start, 'HH:mm:ss').format('h A')} - ${moment(end, 'HH:mm:ss').format('h A')}`;

        return label;
    }
    static convertDurationToTimeFormat = (durationInSeconds) => {
        console.log("durationInSeconds " + durationInSeconds);
        const result = moment.utc(moment.duration(durationInSeconds, "seconds").asMilliseconds()).format('HH:mm:ss')
        console.log(result);
        return result;
    }
    //return 
    // -1 for expired
    //  0 for active
    //  1 for pending
    static checkItemExpiration = (item) => {
        var isExpired = false;
        var isPending = false;
        var isInfinite = false;

        if (item.StartDate !== "" && item.EndDate !== "") {
            var compareDate = moment(Date());
            var startDate = moment(item.StartDate);
            var endDate = moment(item.EndDate);

            // omitting the optional third parameter, 'units'
            isExpired = !compareDate.isBetween(startDate, endDate); //false in this case

            if (isExpired) {
                isPending = compareDate.isBefore(startDate)
            }
        }
        else {
            isInfinite = true;
        }

        if (isExpired) {
            return -1;
        }
        else if (isPending) {
            return 1;
        }
        else {
            return 0;
        }

    }
}

export default MomentHelper